// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/Actions/Content/SyncAction/Content/Action/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_Actions_Content_SyncAction_Content_Action($connection_id: uuid!, $location_id: uuid!) {
  apps_sync(
    where: {
      connection_id: { _eq: $connection_id }
      location_id: { _eq: $location_id }
      status: { _in: [processed, processing, created] }
    }
    order_by: { created_at: desc }
    limit: 1
  ) {
    id
    status
    updated_at
    matches {
      id
    }
  }
}

`